import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { HowToPlayScene } from './scenes/IntroductionScene';
import { GameIntroScene } from 'src/games/PlumbingGame/scenes/GameIntro';

interface PhaserPlumbingGameProps {
    onComplete: () => void;

}

interface PhaserPlumbingGameState {
}

const gameConfig: GameConfig = {
    title: "Plumbing Game",
    version: "0.9.3",
    backgroundColor: "#000000",
    "render.pixelArt": false,
    physics: {
        default: 'arcade',
        arcade: {
            debug: false,
            gravity: { y: 400 }
        }
    },
};

class PhaserPlumbingGame extends React.Component<PhaserPlumbingGameProps, PhaserPlumbingGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserPlumbingGameProps) {
        super(props);
        bindAllOfThis(this, PhaserPlumbingGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserPlumbingGame;



// WEBPACK FOOTER //
// ./src/games/PlumbingGame/Main.tsx